
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image } from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Viele Studien belegen diese Annahme. In den 90er-Jahren kamen `}<Link href='https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3630950/' mdxType="Link">{`Forscher aus den USA`}</Link>{` zum Schluss, dass rund 60 Prozent aller Männer und 40 Prozent der Frauen schnarchen. Eine breit angelegte `}<Link href='https://www.ncbi.nlm.nih.gov/pmc/articles/PMC2276748/table/T1/' mdxType="Link">{`Studie aus Ungarn`}</Link>{`  bestätigte dieses Ergebnis: `}<M mdxType="M">{`Hier schnarchten ebenfalls 60 Prozent der männlichen Probanden und 42 Prozent der weiblichen.`}</M>{` Eine im `}<Link href='http://jcsm.aasm.org/ViewAbstract.aspx?pid=31532' mdxType="Link">{`«Journal of Clinical Sleep Medicine»`}</Link>{` erschienene Studie stellt fest: Bei einer Untersuchung an 1913 Probanden gaben 93 Prozent der Männer an zu schnarchen – was auch der Realität entsprach. Dagegen outeten sich lediglich 72 Prozent der weiblichen Probandinnen als Schnarcherinnen, obwohl in Wahrheit rund 88 Prozent von ihnen sägten. Und das gar nicht so leise: `}<M mdxType="M">{`Mit fast 50 Dezibel schnarchten die Frauen im Schnitt nur gerade zwei Dezibel «leiser» als die Männer.`}</M>{` `}<br /><br />{`
Man sollte dazu aber wissen, dass bei dieser Studie nur Probandinnen und Probanden teilnahmen, die von einem Arzt wegen Schlafproblemen an ein Schlaflabor verwiesen wurden. Es dürfte also besonders viele Schnarcher darunter gehabt haben. Was die Studie aber sehr wohl zeigt, ist, dass Männer ihr Schnarchen ziemlich gut einschätzen können, während Frauen sich eher als Nicht-Schnarcherinnen bezeichnen. Wohl, weil das Geräusch als unschicklich und unweiblich gilt.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;